import { FC, ReactElement, useEffect } from 'react';
import { useGraphQL } from './useGraphQL';
import { ApolloProvider } from '@apollo/client';
import { Loader } from '../../components/Loader';
import { useToast } from 'hooks/useToast';

interface Props {
  children: ReactElement;
}

const GraphQLProvider: FC<Props> = ({ children }) => {
  const { showToast } = useToast();
  const { error, loading, client } = useGraphQL();

  useEffect(() => {
    if (error) {
      showToast(JSON.stringify(error?.message), 'error');
    }
  }, [error, showToast]);

  if (loading) return <Loader text="Loading..." />;

  return <>{client && <ApolloProvider client={client}>{children}</ApolloProvider>}</>;
};

export default GraphQLProvider;
